import React, { useEffect, useMemo, useState } from "react";

// MUI
import { Box, Button, Grid, Typography } from "@mui/material";

// Components
import Divider from "../../Divider";
import DrawerComponent from "../../DrawerComponent";
import PreviewBidDetails from "./PreviewBidDetails";

// Hooks
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux/hooks/redux-hooks";

// Utils
import { isValidArr, trimEllip } from "../../../utility/utils";

// Actions
import { fetchParticularUser } from "../../../redux/actions/UserActions";

export default function ReviewAndSubmitCreation() {
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const get_Project_Object = useAppSelector(
    (state) => state.project.project_Object
  );
  const all_bus = useAppSelector((state) => state.bu.bus_by_SBU);
  const particularUser = useAppSelector((state) => state.user.particular_User);
  const particularUserSBU = useAppSelector(
    (state) => state.sbu.particularUserSBU
  );

  // To get the selected bu details of project
  const selectedBU = useMemo(() => {
    if (get_Project_Object.buid && isValidArr(all_bus)) {
      return all_bus.find((rec) => rec.buid === get_Project_Object.buid);
    }
  }, [all_bus, get_Project_Object.buid]);

  // Fetch user details of BU approval user
  useEffect(() => {
    if (selectedBU?.isApprovalRequired && selectedBU.buuserId) {
      dispatch(fetchParticularUser(selectedBU.buuserId));
    }
  }, [selectedBU, dispatch]);

  const openBidPreviewPanel = () => {
    setIsOpen(true);
  };

  const handleBidPreviewClosePanel = () => {
    setIsOpen(false);
  };

  return (
    <Box>
      <Box
        sx={{
          padding: "1em",
          border: "1px solid rgb(0 0 0 / 18%)",
          borderRadius: "0.375rem",
        }}
      >
        <Typography variant="subtitle1" mt={1} mb={1}>
          Approver Details
        </Typography>
        <Divider />
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Approver
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Name
            </Typography>
          </Grid>

          {selectedBU && selectedBU.isApprovalRequired && (
            <>
              <Grid item xs={4}>
                <Typography variant="subtitle2">BU Head</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2">
                  {particularUser &&
                    `${particularUser.firstName} ${particularUser.lastName}`}
                </Typography>
              </Grid>
            </>
          )}
          <Grid item xs={4}>
            <Typography variant="subtitle2">SBU Head</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2">
              {particularUserSBU.sbuUserName}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2">SBG Head</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2">
              {particularUserSBU.sbgUserName}
            </Typography>
          </Grid>

          {(!get_Project_Object.isBaseLoad ||
            !get_Project_Object.isGreenListCustomer ||
            get_Project_Object.enforceCsgoApproval) && (
            <>
              <Grid item xs={4}>
                <Typography variant="subtitle2">CSGO</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2">
                  {particularUserSBU.csgoUserName}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
        <Typography variant="body2" fontWeight={600} mt={3}>
          You have filled the Bid details, Please review and submit for
          approval.
        </Typography>
      </Box>
      <Button
        variant="outlined"
        sx={{ boxSizing: "border-box", mt: "1rem", width: "100%" }}
        onClick={openBidPreviewPanel}
      >
        Preview
      </Button>

      {isOpen && (
        <DrawerComponent
          open={isOpen}
          title={`${trimEllip(get_Project_Object.projectName)} Preview`}
          onClose={handleBidPreviewClosePanel}
          width="42.5vw"
        >
          <PreviewBidDetails />
        </DrawerComponent>
      )}
    </Box>
  );
}
